'use client';

import { htmlFrom } from '../../utils';
import './styles.css';

export function RichTextRenderer({ html }: { html: string }) {
  return <div className="text-editor">{htmlFrom(html)}</div>;
}
